import React from "react";
import sImg from "../../images/service-single/dream/1.jpg";
import sImg2 from "../../images/service-single/dream/2.jpg";

const DreamSection: React.FC = () => {
  return (
    <section className="dream-section">
      <div className="container-fluid">
        <div className="dream-wrap">
          <div className="title">
            <h2 className="poort-text poort-in-right">Love Made Memorable!</h2>
            <p>
              A wedding is the perfect celebration of two hearts uniting as one.
              From glowing smiles to graceful blooms, every detail crafts
              memories to treasure forever. Tender glances, joyful laughter, and
              heartfelt moments come together to create a day brimming with love
              and beauty. Each promise, every dance, weaves a story that will be
              cherished for a lifetime — making your special day truly
              unforgettable.
            </p>
          </div>

          <div className="image-wrap">
            <div className="row">
              <div
                className="col-lg-6 col-md-6 col-12 scroll-text-animation"
                data-animation="fade_from_bottom"
              >
                <div className="image">
                  <img src={sImg} alt="Wedding memory moment" />
                </div>
              </div>

              <div
                className="col-lg-6 col-md-6 col-12 scroll-text-animation"
                data-animation="fade_from_bottom"
              >
                <div className="image">
                  <img src={sImg2} alt="Romantic wedding decoration" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DreamSection;
